import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./MobileNav.css";
import "./Nav.css";
import { useNavigate } from "react-router";
import { useUserAuth } from "../../User/UserAuthContext/UserAuthContext";
import logo from "../../assests/logo.jpeg";
// import Avtar from "../../components/Images/avatar-placeholder.jpg";
import { useState } from "react";
import { BASE_URL } from "../../api";
import { ROUTES } from "../../config/routes";
import { FaBars, FaTimes } from "react-icons/fa";
import Loader from "../common/Loader";

function MobileNav() {
  const { handleLogout, user } = useUserAuth();
  const [, setProfileData] = useState({ profile_pic: "" });

  const navigate = useNavigate();
  const Logout = async () => {
    const token = localStorage.getItem("token");
    try {
      await fetch(`${BASE_URL}users/logout/`, {
        method: "GET",
        headers: {
          Authorization: `Token ${token}`,
        },
      });
      // console.log(response.data); // Log the response object
    } catch (error) {
      // console.log(error.message);
    } finally {
      handleLogout();
      navigate(ROUTES.home);
    }
  };

  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);

  const closeMenu = () => setClick(false);

  // Student detail data Api-----------------
  const fetchProfileData = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${BASE_URL}users/profile_me/`, {
        method: "GET",
        headers: {
          // Authorization: "Token 672b70e1805f2bffdd924556a36defbe488ffadb",
          Authorization: `Token ${token}`,
        },
      });
      const data = await response.json();
      setProfileData(data.data);

      // console.log(data.data); // log the fetched data
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    if (user) {
      fetchProfileData();
    }
  }, [user]);

  // -------------------NOTIFICATIONS-------------------------
  // -------------------NOTIFICATIONS-------------------------
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showNotifications, setShowNotifications] = useState(false);
  const dropdownRef = useRef();

  const handleNotificationsResponse = (data) => {
    if (data && data.data && Array.isArray(data.data)) {
      setNotifications(data.data.reverse());
    }
    setLoading(false);
  };

  // ...

  useEffect(() => {
    const token = localStorage.getItem("token");

    // Check if the user is logged in and has a valid token
    if (token) {
      fetch(`${BASE_URL}notifications/list/`, {
        headers: {
          Authorization: `Token ${token}`,
        },
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error("Unauthorized");
          }
        })
        .then((data) => {
          handleNotificationsResponse(data);
        })
        .catch((error) => console.error(error));
    }
  }, []);

  const handleShowNotifications = () => {
    setShowNotifications(!showNotifications);
  };

  // Add event listener to detect clicks outside of notification dropdown
  useEffect(() => {
    const handleOutsideClick = (event) => {
      // Check if target of click event is inside the notification dropdown
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);

    // Cleanup function to remove event listener
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [showNotifications]);

  return (
    <div className="mainNav2-bg">
      <div className="Logo">
        <Link to={ROUTES.home}>
          <img src={logo} alt="logo" className="logo-image2" />
        </Link>
      </div>
      {/*-----------Hamburger-Menu-Icons-------- */}
      <div className="Menu-left-hamburger">
        {user ? (
          <li className="nav-item">
            <div
              className="notification-icon"
              onClick={handleShowNotifications}
              ref={dropdownRef}
            >
              <i className="fa fa-bell"></i>
              {showNotifications && (
                <div
                  className="notification-drop-down"
                  onMouseLeave={() => setShowNotifications(false)}
                >
                  {loading ? (
                    <Loader text="Loading notifications..." variant="inline" />
                  ) : (
                    <ul>
                      <Link
                        to={`/NotificationDetail/${notifications.id}`}
                        className="notifiactionitem"
                      >
                        {notifications.map((notification) => (
                          <li key={notification.id}>{notification.message}</li>
                        ))}
                      </Link>
                    </ul>
                  )}
                </div>
              )}
            </div>
          </li>
        ) : (
          <></>
        )}
        <div className="hamburger" onClick={handleClick}>
          {click ? (
            <FaTimes size={30} style={{ color: "black" }} />
          ) : (
            <FaBars size={30} style={{ color: "black" }} />
          )}
        </div>
      </div>
      <ul className={click ? "nav-menu active" : "nav-menu"}>
        <li className="nav-item">
          <Link to={ROUTES.home} onClick={closeMenu}>
            Home
          </Link>
        </li>
        <li className="nav-item">
          <Link to={ROUTES.iscb} onClick={closeMenu}>
            ISCB
          </Link>
        </li>
        <li className="nav-item">
          <Link to={ROUTES.camps} onClick={closeMenu}>
            Camps
          </Link>
        </li>
        <li className="nav-item">
          <Link to={ROUTES.about} onClick={closeMenu}>
            About Us
          </Link>
        </li>
        {user ? (
          <>
            <li className="nav-item">
              <Link to={ROUTES.editProfile} onClick={closeMenu}>
                Edit Profile
              </Link>
            </li>
            <li className="nav-item">
              <Link to={ROUTES.registerForm} onClick={closeMenu}>
                Register Player
              </Link>
            </li>
            <li className="nav-item">
              <Link to={ROUTES.registeredPlayers} onClick={closeMenu}>
                Registered Players List
              </Link>
            </li>
          </>
        ) : (
          <></>
        )}
        {/* Register-Player-Conditional-Render */}
        {/* -------------User-Login-Logout-Coditional-Rendering------------------ */}
        {user ? (
          <div className="LoginBtn">
            <button className="LoginButton" type="button" onClick={Logout}>
              Logout
            </button>
          </div>
        ) : (
          <div className="LoginBtn">
            <Link className="LoginButton" to={ROUTES.login} onClick={closeMenu}>
              Login
            </Link>
          </div>
        )}
      </ul>
    </div>
  );
}

export default MobileNav;
